module.exports = __webpack_public_path__ + "img/24.f0fe7f97.jpg";